var render = function render(){var _vm=this,_c=_vm._self._c;return _c('preview-responsive-container',[(_vm.cmsPage)?_c('cms-block-builder',{attrs:{"blocks":_vm.cmsPage.blocks}}):_vm._e(),_c('modal-feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }